import React from "react";
import BtnLoader from "../BtnLoader/BtnLoader";
import Swal from "sweetalert2";
import SubmitButton from "./SubmitButton";

const Bedrooms = (props) => {
  const {
    bedrooms,
    loaders,
    setBedrooms,
    formData,
    handleSubmit,
    errorsBedrooms,
    setErrorsBedrooms,
  } = props;

  const handlePlusClick = () => {
    const equalBedrooms = bedrooms.reduce(
      (sum, bedroom) => sum + Number(bedroom.bed),
      0
    );
    const maxBed = Number(formData.no_of_bedroom) || 0;
    if (equalBedrooms >= maxBed) {
      Swal.fire({
        icon: "warning",
        title:
          "Hold short - the number of bedrooms you stated above is different from the number of bedrooms you are entering here. If this is OK with you, please continue.",
      });
      setBedrooms([...bedrooms, { name: "", guest: "", bed: "", type: "" }]);
    } else {
      setBedrooms([...bedrooms, { name: "", guest: "", bed: "", type: "" }]);
    }
  };
  const handleMinusClick = (index) => {
    if (bedrooms.length > 1) {
      const newBedrooms = [...bedrooms];
      newBedrooms.splice(index, 1);
      setBedrooms(newBedrooms);
    }
  };

  const handleInputChangess = (value, index, field) => {
    const newBedrooms = [...bedrooms];
    newBedrooms[index][field] = value;
    props.setBedrooms(newBedrooms);
    const newErrors = [...errorsBedrooms];
    if (newErrors[index]) {
      newErrors[index][field] = !value;
    } else {
      newErrors[index] = { [field]: !value };
    }
    setErrorsBedrooms(newErrors);
  };
  const labelIcons = {
    "Bedroom Name": "fal fa-bed", // Icon for bedroom name
    "Number of Guests": "fal fa-user-friends", // Icon for guests
    "Number of Beds": "fal fa-bed", // Icon for number of beds
    "Bed Type": "fal fa-couch", // Icon for bed type (couch is a good generic choice)
  };

  const getIconClass = (label) => labelIcons[label] || "fal fa-question-circle";
  return (
    <>
      <div className="grid md:grid-cols-12 bg-white p-4 rounded-lg gap-4">
        <h3 className="text-xl font-bold text-center md:col-span-12">
          Bedrooms
        </h3>
        {bedrooms?.map((bedroom, index) => (
          <>
            <div className="md:col-span-6 text-left">
              <label>Bedroom Name</label>
              <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                <i className={getIconClass("Bedroom Name")} />
                <input
                  type="text"
                  placeholder="Ex. Master Bedroom, Bedroom 3"
                  className="w-full"
                  value={bedroom.name}
                  onChange={(e) =>
                    handleInputChangess(e.target.value, index, "name")
                  }
                />
              </div>
              {errorsBedrooms[index]?.name && (
                <p style={{ color: "red" }}>Required</p>
              )}
            </div>

            <div className="md:col-span-6 text-left">
              <label>Number of Guests</label>
              <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                <i className={getIconClass("Number of Guests")} />
                <input
                  type="number"
                  placeholder="Enter the no. of guests in this room."
                  className="w-full"
                  value={bedroom.guest}
                  onChange={(e) =>
                    handleInputChangess(e.target.value, index, "guest")
                  }
                />
              </div>
              {errorsBedrooms[index]?.guest && (
                <p style={{ color: "red" }}>Required</p>
              )}
            </div>

            <div className="md:col-span-6 text-left">
              <label>Number of Beds</label>
              <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                <i className={getIconClass("Number of Beds")} />
                <input
                  type="number"
                  placeholder="Enter the no. of beds in this room"
                  className="w-full"
                  value={bedroom.bed}
                  onChange={(e) =>
                    handleInputChangess(e.target.value, index, "bed")
                  }
                />
              </div>
              {errorsBedrooms[index]?.bed && (
                <p style={{ color: "red" }}>Required</p>
              )}
            </div>

            <div className="md:col-span-6 text-left">
              <label>Bed Type</label>
              <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full">
                <i className={getIconClass("Bed Type")} />
                <input
                  type="text"
                  placeholder="Ex. King, Queen, Trundle, Bunk Beds"
                  className="w-full"
                  value={bedroom.type}
                  onChange={(e) =>
                    handleInputChangess(e.target.value, index, "type")
                  }
                />
              </div>
              {errorsBedrooms[index]?.type && (
                <p style={{ color: "red" }}>Required</p>
              )}
            </div>

            <div className="md:col-span-12 flex justify-start items-start">
              {bedrooms?.length > 1 && (
                <button
                  className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                  onClick={() => handleMinusClick(index)}
                >
                  Remove Bedroom
                </button>
              )}
            </div>
          </>
        ))}

        <div className="md:col-span-12 text-left flex justify-end items-end">
          <button
            onClick={handlePlusClick}
            className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
          >
            Add bedrooms
          </button>
        </div>

        <div className="md:col-span-12 text-left flex justify-end items-end gap-4">
          <button className="border border-[#3b4249] font-medium bg-[#54c4d9] rounded-md text-white px-8 py-3">
            {loaders ? <BtnLoader /> : <>Save as Draft</>}
          </button>
          <SubmitButton handleSubmit={handleSubmit} loaders={loaders} />
        </div>
      </div>
    </>
  );
};

export default Bedrooms;
